import React from "react";

function Footer({ mt = 3 }) {
  return (
    <div className={`footerAvant mt-${mt}`}>
      <p>Footer</p>
      <p>infor@gmail.com</p>
    </div>
  );
}

export default Footer;
